import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MaterialModule } from '@app/_shared/material.module';

@Component({
  selector: 'app-unsaved-info-warning-dialog',
  imports: [MaterialModule],
  templateUrl: './unsaved-info-warning-dialog.component.html',
  styleUrl: './unsaved-info-warning-dialog.component.scss'
})
export class UnsavedInfoWarningDialogComponent implements OnInit {
  constructor(
    private dialogRef: MatDialogRef<UnsavedInfoWarningDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {}

  _cancel() {
    this.dialogRef.close(false);
  }

  _continue() {
    this.dialogRef.close(true);
  }
}
